export default __webpack_public_path__ + "static/73f7c4df07fccf27ef7c6ee7e2cac77b.webp";